(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const blockSelector = '[data-contact-enquiry]';

    const updateEnquiryFields = (block) => {
      const select = block.querySelector('[data-contact-enquiry-select]');
      if (!select) return;

      const selectedOption = select.options[select.selectedIndex];
      const activePanel = selectedOption ? selectedOption.dataset.contactEnquiryTarget || '' : '';

      block.querySelectorAll('[data-contact-enquiry-panel]').forEach((panel) => {
        const isActive = panel.dataset.contactEnquiryPanel === activePanel;
        panel.hidden = !isActive;

        panel.querySelectorAll('[data-contact-enquiry-input]').forEach((field) => {
          field.disabled = !isActive;

          if (field.dataset.contactEnquiryRequired === 'true') {
            field.required = isActive;
            field.setAttribute('aria-required', String(isActive));
          }
        });
      });
    };

    const initializeEnquiryFields = (container) => {
      container.querySelectorAll(blockSelector).forEach((block) => {
        if (block.dataset.contactEnquiryReady === 'true') return;

        const select = block.querySelector('[data-contact-enquiry-select]');
        if (!select) return;

        block.dataset.contactEnquiryReady = 'true';
        select.addEventListener('change', () => updateEnquiryFields(block));
        updateEnquiryFields(block);
      });
    };

    const initializePage = () => initializeEnquiryFields(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializePage, { once: true });
    } else {
      initializePage();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeEnquiryFields(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rugby-position-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const guideSelector = '[data-position-guide-interactive]';

    const getNumbers = (value) => {
      return String(value || '')
        .split(',')
        .map((number) => number.trim())
        .filter(Boolean);
    };

    const updateGuide = (guide, groupId, numbers, persist) => {
      const activeNumbers = getNumbers(numbers);

      guide.querySelectorAll('[data-position-number]').forEach((button) => {
        const isActive = activeNumbers.includes(button.dataset.positionNumber);
        button.classList.toggle('rugby-position-guide__position--active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      guide.querySelectorAll('[data-position-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.positionPanel !== groupId;
      });

      if (persist) {
        guide.dataset.positionSelectedGroup = groupId;
        guide.dataset.positionSelectedNumbers = activeNumbers.join(',');
      }
    };

    const selectButton = (guide, button, persist) => {
      updateGuide(
        guide,
        button.dataset.positionGroupId || 'fallback',
        button.dataset.positionGroupNumbers || button.dataset.positionNumber,
        persist
      );
    };

    const restoreSelection = (guide) => {
      updateGuide(
        guide,
        guide.dataset.positionSelectedGroup || 'fallback',
        guide.dataset.positionSelectedNumbers || '',
        false
      );
    };

    const initializeGuide = (guide) => {
      const initializerVersion = 'persistent-hover-v2';
      if (guide.dataset.positionGuideReady === initializerVersion) return;

      const pitch = guide.querySelector('.rugby-position-guide__pitch');
      if (!pitch) return;

      guide.dataset.positionGuideReady = initializerVersion;

      pitch.querySelectorAll('[data-position-group-id]').forEach((button) => {
        button.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch') selectButton(guide, button, true);
        });

        button.addEventListener('focus', () => selectButton(guide, button, true));

        button.addEventListener('click', () => selectButton(guide, button, true));
      });

      restoreSelection(guide);
    };

    const initializeGuides = (container) => {
      container.querySelectorAll(guideSelector).forEach(initializeGuide);
    };

    const initializePage = () => initializeGuides(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializePage, { once: true });
    } else {
      initializePage();
    }

    document.addEventListener('shopify:section:load', (event) => initializeGuides(event.target));

    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-position-panel]');
      if (!panel) return;

      const guide = panel.closest(guideSelector);
      if (!guide) return;

      updateGuide(
        guide,
        panel.dataset.positionPanel,
        panel.dataset.positionNumbers || '',
        true
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('size-guide-directory')) {
    customElements.define(
      'size-guide-directory',
      class SizeGuideDirectory extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.cache = new Map();
          this.scopeInstance = 0;
          this.dialog = this.querySelector('[data-size-guide-dialog]');
          this.dialogContent = this.querySelector('[data-size-guide-dialog-content]');
          this.dialogTitle = this.querySelector('[data-size-guide-dialog-title]');
          this.fullPageLink = this.querySelector('[data-size-guide-full-page-link]');
          this.lastTrigger = null;
          this.requestToken = 0;

          this.addEventListener('click', (event) => {
            const link = event.target.closest('[data-size-guide-modal-link]');
            if (!link || !this.contains(link)) return;

            const destination = new URL(link.href, window.location.href);
            if (destination.origin !== window.location.origin) return;

            event.preventDefault();
            this.openGuide(link, destination);
          });

          const search = this.querySelector('[data-size-guide-search]');
          if (search) search.addEventListener('input', () => this.filterBrands(search.value));

          this.querySelector('[data-size-guide-dialog-close]')?.addEventListener('click', () => this.dialog.close());
          this.dialog?.addEventListener('click', (event) => this.closeFromBackdrop(event));
          this.dialog?.addEventListener('close', () => {
            document.documentElement.classList.remove('size-guide-modal-open');
            this.lastTrigger?.focus({ preventScroll: true });
          });
        }

        filterBrands(value) {
          const query = value.trim().toLowerCase();
          const searchIsActive = query.length > 0;
          let visibleCards = 0;

          this.querySelectorAll('[data-size-guide-card]').forEach((card) => {
            if (searchIsActive && !this.searchIsActive) {
              card.dataset.openBeforeSearch = card.open ? 'true' : 'false';
            }

            const matches = !query || card.dataset.brandSearchText.includes(query);
            card.hidden = !matches;
            if (matches) {
              visibleCards += 1;
              if (searchIsActive) card.open = true;
            }

            if (!searchIsActive && this.searchIsActive) {
              card.open = card.dataset.openBeforeSearch === 'true';
              delete card.dataset.openBeforeSearch;
            }
          });

          this.searchIsActive = searchIsActive;

          const noResults = this.querySelector('[data-size-guide-no-results]');
          if (noResults) noResults.hidden = visibleCards > 0;
        }

        async openGuide(link, destination) {
          if (!this.dialog || !this.dialogContent) return;

          this.lastTrigger = link;
          this.dialogTitle.textContent = link.dataset.guideTitle || link.textContent.trim();
          this.fullPageLink.href = destination.href;
          this.setStatus(this.dataset.loadingText || 'Loading size guide…');

          if (!this.dialog.open) this.dialog.showModal();
          document.documentElement.classList.add('size-guide-modal-open');

          const cacheKey = destination.pathname + destination.search;
          const token = ++this.requestToken;

          try {
            let html = this.cache.get(cacheKey);

            if (!html) {
              const requestUrl = new URL(destination.href);
              requestUrl.searchParams.set('section_id', 'size-guide-modal-content');
              const response = await fetch(requestUrl.toString(), {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
              });

              if (!response.ok) throw new Error(`Size guide request failed: ${response.status}`);
              html = await response.text();
              if (!html.trim()) throw new Error('Size guide response was empty');
              this.cache.set(cacheKey, html);
            }

            if (token !== this.requestToken) return;
            this.dialogContent.innerHTML = html;
            this.dialogContent.removeAttribute('aria-busy');
            this.scopeSizeGuideControls();
          } catch (error) {
            if (token !== this.requestToken) return;
            this.setStatus(this.dataset.errorText || 'This size guide could not be loaded. Open the full page instead.');
          }
        }

        setStatus(message) {
          this.dialogContent.replaceChildren();
          this.dialogContent.setAttribute('aria-busy', 'true');
          const status = document.createElement('p');
          status.className = 'size-guide-directory__dialog-status';
          status.textContent = message;
          this.dialogContent.appendChild(status);
        }

        closeFromBackdrop(event) {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
          if (!inside) this.dialog.close();
        }

        scopeSizeGuideControls() {
          this.dialogContent.querySelectorAll('.sg-switch').forEach((switcher) => {
            const radios = switcher.querySelectorAll(':scope > input[type="radio"]');
            if (!radios.length) return;

            const suffix = `directory-${this.dataset.sectionId}-${++this.scopeInstance}`;
            radios.forEach((radio) => {
              const originalId = radio.id;
              radio.id = `${originalId}-${suffix}`;
              radio.name = `${radio.name || 'size-guide-units'}-${suffix}`;

              switcher.querySelectorAll('.sg-controls label').forEach((label) => {
                if (label.htmlFor === originalId) label.htmlFor = radio.id;
              });
            });

            if (![...radios].some((radio) => radio.checked)) radios[0].checked = true;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
